import request from "../../request";
import React from "react";
import { Tag } from "antd";
export const getLloji = async () => {
  let response = await request({}, `/api/lloj/GetAllLlojet`, "index");
  return response;
};
export const getStatus = async () => {
  let response = await request({}, `/api/status/GetAllStatuset`, "index");
  return response;
};
export const getPropozues = async () => {
  let response = await request({}, `/api/propozues/GetAllPropozuesit`, "index");
  return response;
};
export const getProcedura = async () => {
  let response = await request({}, `/api/procedura/GetAllProcedurat`, "index");
  return response;
};

export default async () => {
  let response = await Promise.all([
    getLloji(),
    getStatus(),
    getPropozues(),
    getProcedura()
  ]);
  console.log(response);
  return [
    {
      Titulli: "kerko per procesverbale",
      url: "/procesverbale",
      per_page: 10,
      serverUrl: "/procesverbale",
      filters: [
        {
          name: "Emri i Aktit",
          type: "text",
          queryName: "Titulli"
        },
        {
          name: "Lloji",
          type: "select",
          values: response[0],
          queryName: "LlojiID"
        },
        {
          name: "Statusi",
          type: "select",
          values: response[1],
          queryName: "StatusID"
        },
        {
          name: "Propozues",
          type: "select",
          values: response[2],
          queryName: ""
        },
        {
          name: "Procedura",
          type: "select",
          values: response[3],
          queryName: "ProceduraID"
        }
      ],
      table: [
        {
          title: "Titulli",
          dataIndex: "Titulli",
          key: "Titulli"
        },
        {
          title: "Date Regjistrimi",
          dataIndex: "DateRegjistrimi",
          key: "DateRegjistrimi"
        },

        {
          title: "Statusi",
          dataIndex: "Statusi",
          key: "Statusi"
        },
        {
          title: "Procedura",
          dataIndex: "Procedura",
          key: "Procedura"
        },
        {
          title: "Lloji",
          dataIndex: "Lloji",
          key: "Procedura"
        },
        {
          title: "",
          dataIndex: "id",
          key: "id",
          render: tags => (
            <span>
              <Tag color={"blue"}>Shiko me shume</Tag>
            </span>
          )
        }
      ]
    }
  ];
};

export const getRows = async filters => {
  let filtersString = "";
  var index = 0;
  console.log(filters);
  for (var key in filters) {
    if (filters.hasOwnProperty(key)) {
      if (key !== "Propozues") {
        if (index > 0) {
          if (filters[key].name === "Titulli") {
            filtersString =
              filtersString +
              ` and contains(${filters[key].name},'${filters[key].id}')`;
            index++;
          } else {
            filtersString =
              filtersString + ` and ${filters[key].name} eq ${filters[key].id}`;
            index++;
          }
        } else {
          if (filters[key].name === "Titulli") {
            filtersString =
              filtersString +
              `&$filter=contains(${filters[key].name},'${filters[key].id}')`;
            index++;
          } else {
            filtersString =
              filtersString +
              `&$filter=${filters[key].name} eq ${filters[key].id}`;
            index++;
          }
        }
      }
    }
  }
  console.log(filtersString);
  let response = await request(
    {},
    `/api/bill/GetAllBills?$expand=statusi,billPropozues,lloji,statusi,procedura&$orderby=ID desc${filtersString}`,
    "index"
  );
  let hasPropozues = [];
  if (filters["Propozues"]) {
    console.log(filters["Propozues"], "");
    response.map(row => {
      var isTrue = false;
      row.BillPropozues.map(propozues => {
        console.log(filters["Propozues"], propozues.PropozuesID);
        if (propozues.PropozuesID === filters["Propozues"]) {
          isTrue = true;
        }
        return true;
      });
      if (isTrue) {
        hasPropozues.push(row);
      }
      return true;
    });
  } else {
    hasPropozues = response;
  }
  hasPropozues = hasPropozues.map(row => {
    row.Lloji = row.Lloji.Emri;
    row.Statusi = row.Statusi.Emri;
    row.Procedura = row.Procedura.Emri;
    row.DateRegjistrimi = row.DateRegjistrimi.slice(0, 10);

    return row;
  });
  console.log(hasPropozues);
  return hasPropozues;
};
export const getBillById = async id => {
  let response = await request(
    {},
    `/api/bill/GetBillByID/${id}?$expand=statusi,lloji,statusi,procedura&$expand=billPropozues($expand=Propozues)&$expand=dokumentat($expand=TipDok)&$expand=StruktureBill($expand=Struktura)`,
    "index"
  );
  return response;
};
